import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getSchoolClassesConfig } from '../../apis/schoolConfig';
import { RootState } from '../../redux/store';
import { SchoolClassesConfig } from '../../types/schoolConfigType';
import ExamsCrudPage from './ExamsCrudPage';
import ToastMessage from '../../components/ToastMessage';
import { SnackbarSeverityType } from '../../enums';

const ExamsCrudContainer: React.FC = () => {
  const [allClasses, setAllClasses] = useState<SchoolClassesConfig>();
  const [isClassesLoading, setIsClassesLoading] = useState<boolean>(false);
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<SnackbarSeverityType>(
    SnackbarSeverityType.success
  );

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  useEffect(() => {
    setIsClassesLoading(true);
    getSchoolClassesConfig(loggedInUser.school)
      .then((response) => {
        setAllClasses(response.data as unknown as SchoolClassesConfig);
      })
      .catch((error) => {
        console.error(error);
        setToastMessage('Failed to load school configuration.');
        setToastSeverity(SnackbarSeverityType.error);
        setToastOpen(true);
      })
      .finally(() => setIsClassesLoading(false));
  }, [loggedInUser]);

  return (
    <>
      <ExamsCrudPage
        allClasses={allClasses as SchoolClassesConfig}
        school={loggedInUser.school}
        etherId={loggedInUser.etherId}
        isClassesLoading={isClassesLoading}
      />
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </>
  );
};

export default ExamsCrudContainer;
